export default __webpack_public_path__ + "static/media/7.2da7b568.png";